import { useMsal } from "@azure/msal-react";
import { Button } from "primereact/button";
import { loginRequest } from "../../config/authConfig";
import { useState } from "react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Navigate } from "react-router-dom";

const SignIn = ({ show }: any) => {
  const { instance } = useMsal();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleLogin = async () => {
    try {
      if (import.meta.env.VITE_MODE === "production") {
        const loginResponse = await instance.loginPopup(loginRequest);

        if (loginResponse.idToken) {
          if (sessionStorage.getItem("idToken") === null) {
            sessionStorage.setItem("idToken", loginResponse.idToken);
            sessionStorage.setItem(
              "account",
              JSON.stringify(loginResponse.account)
            );
          }
        }
      } else {
        await instance.loginRedirect(loginRequest);
      }
    } catch (error) {
      // Manejar el caso en que acquireTokenSilent falla, por ejemplo,
      // redirigiendo al usuario para que inicie sesión de nuevo
      if (error instanceof InteractionRequiredAuthError) {
        console.log("Interaction required. Redirecting to login...");
        // This is the key: redirect the user to log in
        return <Navigate replace to="/" />;
      }
      console.error("Error al adquirir el token o llamar a la API:", error);
    }
  };

  return (
    <Button
      style={
        show
          ? styles.disabledAdLoginButton
          : {
              ...styles.enabledAdLoginButton,
              backgroundColor: isHovered ? "white" : "red",
              color: isHovered ? "black" : "white",
            }
      }
      icon="pi pi-microsoft"
      label="ACCEDE CON MICROSOFT"
      onClick={() => handleLogin()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      text
      disabled={show}
    ></Button>
  );
};

const styles = {
  disabledLoginButton: {
    backgroundColor: "gray",
    color: "white",
    cursor: "not-allowed",
    margin: 10,
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },
  enabledLoginButton: {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    margin: 10,
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },

  enabledLoginButtonHover: {
    backgroundColor: "white",
    color: "black",
    cursor: "pointer",
    margin: 10,
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
  },

  disabledAdLoginButton: {
    backgroundColor: "gray",
    cursor: "not-allowed",
    boxShadow: "0px 0px 10px 0px grey",
    margin: "20px",
    height: "7%",
    padding: "10px",
    color: "white",
    fontFamily: "math",
    fontSize: "12px",
  },
  enabledAdLoginButton: {
    backgroundColor: "red",
    color: "white",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
    boxShadow: "0px 0px 10px 0px grey",
    margin: "20px",
    height: "7%",
    padding: "10px",
    fontFamily: "math",
    fontSize: "12px",
  },
  errorMessage: {
    display: "inherit",
    fontSize: "10px",
    color: "#ff3d3d",
  },
};
export default SignIn;
